<template>
    <div class="home">
    <section class="hero">
    <div class="hero-image">
    </div>
    <div class="container hero-content">
    <span class="eyebrow hero-eyebrow">REAL ESTATE · LAGOS & BEYOND</span>
    <h1>Property solutions<br>
    <em>built around</em> your future.</h1>
    <p>From finding the right property to managing and developing real estate assets, we provide professional solutions backed by market knowledge and experience.</p>
    <div class="hero-actions">
    <router-link to="/properties" class="button light">Explore Properties <span>↗</span>
    </router-link>
    <router-link to="/contact" class="button ghost-light">Talk to an Expert <span>→</span>
    </router-link>
    </div>
    </div>
    <div class="container hero-search">
    <PropertySearch @search="goSearch"/>
    </div>
    </section>
<section class="intro section">
    <div class="container split">
    <div>
    <span class="eyebrow">A DIFFERENT APPROACH</span>
    <h2>Real estate decisions deserve more than a listing.</h2>
    </div>
    <div>
    <p class="lead">We bring property advisory, sales, management and development together so you can make decisions with greater clarity—from your first viewing to the long-term care of your asset.</p>
    <router-link to="/about" class="text-link">Discover Aurelia <span>↗</span>
    </router-link>
    </div>
    </div>
    </section>
<section class="section properties-section">
    <div class="container">
    <SectionHeader eyebrow="FEATURED PROPERTIES" title="Find your next property" text="A considered selection of homes and investment opportunities across some of Lagos' most sought-after neighbourhoods."/>
    <div class="featured-grid">
    <PropertyCard v-for="p in featured" :key="p.id" :property="p"/>
    </div>
    <div class="center-action">
    <router-link to="/properties" class="button outline">View all properties <span>↗</span>
    </router-link>
    </div>
    </div>
    </section>
<section class="service-band">
    <div class="container split">
    <div>
    <span class="eyebrow">WHAT WE DO</span>
    <h2>One team.<br>
    <em>More ways</em> to move forward.</h2>
    </div>
    <div class="service-list">
    <div v-for="s in services.slice(0,4)" :key="s.id">
    <span>0{{s.id}}</span>
    <h3>{{s.title}}</h3>
    <p>{{s.description}}</p>
    </div>
    <router-link to="/services" class="text-link light-link">View all services <span>↗</span>
    </router-link>
    </div>
    </div>
    </section>
<section class="projects-home section">
    <div class="container">
    <div class="section-row">
    <SectionHeader eyebrow="OUR PROJECTS" title="Places with purpose" text="Development and project work shaped around context, quality and lasting value."/>
    <router-link to="/projects" class="text-link">View projects <span>↗</span>
    </router-link>
    </div>
    <div class="projects-grid">
    <ProjectCard v-for="p in projects" :key="p.id" :project="p"/>
    </div>
    </div>
    </section>
<section class="quote-section">
    <div class="container">
    <span class="eyebrow">THE AURELIA STANDARD</span>
    <blockquote>“Good property advice should make a complex decision feel clear, considered and personal.”</blockquote>
    <span class="quote-by">— Tomi Adeyemi, Managing Director</span>
    </div>
    </section>
<section class="section blog-home">
    <div class="container">
    <div class="section-row">
    <SectionHeader eyebrow="FROM THE JOURNAL" title="Ideas for property owners and buyers"/>
    <router-link to="/blog" class="text-link">Read the journal <span>↗</span>
    </router-link>
    </div>
    <div class="blog-grid">
    <BlogCard v-for="post in posts.slice(0,3)" :key="post.id" :post="post"/>
    </div>
    </div>
    </section>
    <CTASection/>
    </div>
    </template>
<script>import {properties} from '@/data/properties'; import services from '@/data/services'; import projects from '@/data/projects'; import posts from '@/data/posts'; import PropertySearch from '@/components/property/PropertySearch.vue'; import PropertyCard from '@/components/property/PropertyCard.vue'; import ProjectCard from '@/components/projects/ProjectCard.vue'; import BlogCard from '@/components/blog/BlogCard.vue'; import SectionHeader from '@/components/common/SectionHeader.vue'; import CTASection from '@/components/common/CTASection.vue'; export default {name:'Home',components:{PropertySearch,PropertyCard,ProjectCard,BlogCard,SectionHeader,CTASection},data(){return{properties,services,projects,posts}},computed:{featured(){return this.properties.filter(x=>x.featured).slice(0,4)}},methods:{goSearch(filters){this.$router.push({path:'/properties',query:{...filters}})}}}</script>
